import Avatar from '@atlaskit/avatar';
import { Box, Heading, Skeleton } from '@fuegokit/react';
import { ReactNode } from 'react';

import { JiraUser } from '../../types';
import { getDisplayName } from './utils';

export function UserDetails({
  children,
  loading = false,
  user,
}: {
  children: ReactNode;
  loading?: boolean;
  user?: JiraUser;
}) {
  const displayName = getDisplayName(user);
  return (
    <Box
      display="flex"
      flexDirection="column"
      border="2px solid"
      borderRadius={1}
      borderColor="border.default"
    >
      <Box
        display="flex"
        mx={1}
        p={2}
        sx={{ gap: '10px' }}
        alignItems="center"
        borderBottom="2px solid"
        borderColor="border.default"
      >
        <Avatar
          appearance="circle"
          src={user?.avatarUrls?.['48x48']}
          size="medium"
          name={displayName}
        />
        <Heading
          variant="h600"
          sx={{
            overflow: 'hidden',
          }}
        >
          {loading ? (
            <Skeleton height={24} sx={{ marginBottom: 0 }} width={200} />
          ) : (
            <div
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {displayName}
            </div>
          )}
        </Heading>
      </Box>

      <Box display="flex" flex={1} flexDirection="column" p="12px">
        {children}
      </Box>
    </Box>
  );
}
